import React, { ReactNode, useContext } from "react";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";


interface BaseRoundButtonProps {
  buttonText?: ReactNode;
  className?: string;
  buttonSubText?: ReactNode; // ボタン内のサブテキスト
  isActive?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  id?: string;
  title?: string;
  memo?: string; // 明細一覧のメモ用
  loadingNegative?: boolean; // ローディング中にボタンを押させないようにするか trueだと押せない
}

export const BaseRoundButton = ({
  buttonText,
  className = "",
  buttonSubText,
  isActive = true,
  onClick,
  id = "",
  title = "",
  memo = "",
  loadingNegative = false,
}: BaseRoundButtonProps) => {
  const { isLoading, activeButtonId, setActiveButtonId } = useContext(LoadingModalContext);
  const isButtonLoading = isLoading && activeButtonId === id && id !== "";

  const handleClick = (e: React.MouseEvent) => {
    if (loadingNegative && isLoading) {
      return;
    }
    if (isActive) {
      if (!isLoading && id) {
        setActiveButtonId(id);
      }
      onClick?.(e);
    }
  };

  return (
    <button
      id={id}
      type="button"
      className={`${className}${isButtonLoading ? " load" : ""}`}
      onClick={handleClick}
      {...(isActive === false && { disabled: true })}
      {...(title !== "" && { title: title })}
      {...(memo !== "" ? { "data-tooltip": memo } : undefined)}
    >
      {buttonText && buttonText}
      {buttonSubText && buttonSubText}
    </button>
  );
};

// 最終的にファイル名などもBaseButtonに変更予定